export enum TRANSACTION_STATUS {
  New = 5,
  Paid = 1,
  Deleted = 4,
  Pending = 2,
  Declined = 6,
  InProgress = 3,
}
